/** Presentation only: keep the saved evidence unchanged. */
export const prettifyEvidencePlaceholder = (text: string) =>
    text.replace(/\bNO ANSWER SELECTED\b/g, "No answer selected");

export interface EvidenceSpan {
    text: string;
    emphasis: boolean;
}

/** Only interpret paired Markdown delimiters; preserve clinical symbols and units. */
export function evidenceSpans(text: string): EvidenceSpan[] {
    const spans: EvidenceSpan[] = [];
    const pattern = /(\*\*\*|\*\*|\*|`)([^\n]+?)\1/g;
    let end = 0;
    for (const match of text.matchAll(pattern)) {
        if (match.index > end) {
            spans.push({
                text: prettifyEvidencePlaceholder(text.slice(end, match.index)),
                emphasis: false
            });
        }
        spans.push({ text: prettifyEvidencePlaceholder(match[2]), emphasis: true });
        end = match.index + match[0].length;
    }
    if (end < text.length) {
        spans.push({ text: prettifyEvidencePlaceholder(text.slice(end)), emphasis: false });
    }
    return spans;
}

export interface EvidenceLine {
    kind: "heading" | "bullet" | "row" | "text";
    cells: string[];
}

export function evidenceLines(text: string): EvidenceLine[] {
    return text.split(/\r?\n/).flatMap((raw): EvidenceLine[] => {
        const line = raw.trim();
        if (!line || /^[-*_]{3,}$/.test(line)) {
            return [];
        }
        if (line.startsWith("|") && line.endsWith("|")) {
            const cells = line
                .slice(1, -1)
                .split("|")
                .map((cell) => cell.trim());
            if (cells.every((cell) => /^:?-{3,}:?$/.test(cell))) {
                return [];
            }
            return [{ kind: "row", cells }];
        }
        if (/^#{1,6}\s/.test(line)) {
            return [{ kind: "heading", cells: [line.replace(/^#{1,6}\s+/, "")] }];
        }
        if (/^\*{2,3}[^*]+\*{2,3}$/.test(line)) {
            return [{ kind: "heading", cells: [line] }];
        }
        if (/^[-*+]\s/.test(line)) {
            return [{ kind: "bullet", cells: [line.replace(/^[-*+]\s+/, "")] }];
        }
        return [{ kind: "text", cells: [line] }];
    });
}
